import React, { useEffect, useState } from 'react';
import { auth } from '../firebase'; // Firebase auth import kora holo
import { onAuthStateChanged } from 'firebase/auth';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  
  useEffect(() => {
    // User-er login status check kora
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User login kora ache
        setIsLoggedIn(true);
      } else {
        // User login kora nei
        setIsLoggedIn(false);
      }
      setLoading(false);
    });

    // component unmount hole listener off kora
    return () => unsubscribe();
  }, []);

  if (loading) {
    // Check kora obosthay loading dekhano
    return <p>Loading application...</p>;
  }

  if (!isLoggedIn) {
    // Jodi login kora na thake, login page-e pathiye deya
    return <Navigate to="/login" replace />;
  }

  // Jodi login kora thake, tahole Dashboard (ba children) dekhano
  return children;
};

export default ProtectedRoute;